import React from "react";
import { CHART_COLORS } from "@/features/investors/components/charts/palette";

export type FunnelChartStep = {
    label: string;
    value: number;
    color?: string;
};

type Props = {
    steps: FunnelChartStep[];
    color?: string;
    showPct?: boolean;
    formatValue: (value: number) => string;
};

export const FunnelChart: React.FC<Props> = ({
    steps,
    color = CHART_COLORS.blue,
    showPct = true,
    formatValue,
}) => {
    if (steps.length === 0 || steps[0].value <= 0) return null;
    const base = steps[0].value;

    return (
        <div className="funnel">
            {steps.map((step) => {
                const pct = (step.value / base) * 100;
                const fill = step.color !== undefined ? step.color : color;
                return (
                    <div
                        key={step.label}
                        className="funnel-step"
                        data-tip={`<b>${step.label}</b><br>${formatValue(step.value)} · ${pct.toFixed(1)}% of top`}
                    >
                        <div className="funnel-meta">
                            <span className="funnel-lab">{step.label}</span>
                            <span className="funnel-val">
                                {formatValue(step.value)}
                                {showPct ? <em>{pct.toFixed(0)}%</em> : null}
                            </span>
                        </div>
                        <div className="funnel-bar-wrap">
                            <div
                                className="funnel-bar"
                                style={{
                                    width: `${pct.toFixed(1)}%`,
                                    background: `linear-gradient(90deg,${fill},${fill}AA)`,
                                }}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
